import * as Yup from 'yup';

import messages from '../../../constants/messages.constants';

const { required } = messages;

export const EditPaymentDateFormSchema = Yup.object().shape({
  date: Yup.string().required(required),
});
